import React, { useState } from "react";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  HttpLink,
} from "@apollo/client";

import {
  podcastSelectionStateVariables,
  PodcastSelectionInterface,
} from "./PodcastSelectionInterface";
import { PodcastSelector } from "./PodcastSelector";
import { clipsView } from "./clipsView";
import { PodcastClipAudioPlayer } from "./PodcastClipAudioPlayer";
import "./YouTubeLikeDemo.css";
import { ClientClipProjection } from "./ViewModels/ClientClipProjection";
import {
  DurationKindSelectorInterface,
  mediumDurationKindSelector,
} from "./DurationKind";
import { DurationKindSelector } from "./DurationKindSelector";

const createPublicPodrankApolloClient = () =>
  new ApolloClient({
    link: new HttpLink({
      uri: "https://outgoing-sloth-44.hasura.app/v1/graphql",
    }),
    cache: new InMemoryCache(),
  });

export function YouTubeLikeDemo(props: {
  allPodcasts: PodcastSelectionInterface[];
}) {
  const { allPodcasts } = props;
  const [podrankApolloGqlClient] = useState(createPublicPodrankApolloClient());

  const [selectedPodcasts, setSelectedPodcasts] =
    podcastSelectionStateVariables([allPodcasts[0]]);

  const [selectedDurationKind, setSelectedDurationKind] =
    useState<DurationKindSelectorInterface>(mediumDurationKindSelector);

  const [refreshState, setRefreshState] = React.useState(0);
  const performRefresh: () => void = () => {
    setRefreshState(refreshState + 1);
  };

  const [selectedClipState, setSelectedClipState] =
    useState<ClientClipProjection | null>(null);

  return (
    <ApolloProvider client={podrankApolloGqlClient}>
      <section className="YouTubeLikeDemo">
        {selectedClipState && PodcastClipAudioPlayer(selectedClipState)}

        {PodcastSelector(allPodcasts, selectedPodcasts, setSelectedPodcasts)}
        {DurationKindSelector(selectedDurationKind, setSelectedDurationKind)}
        {clipsView(
          podrankApolloGqlClient,
          selectedPodcasts,
          selectedDurationKind.value,
          refreshState,
          setSelectedClipState,
          performRefresh
        )}
      </section>
    </ApolloProvider>
  );
}
